import { render, staticRenderFns } from "./setDetails.vue?vue&type=template&id=0dbec40b&scoped=true&"
import script from "./setDetails.vue?vue&type=script&lang=js&"
export * from "./setDetails.vue?vue&type=script&lang=js&"
import style0 from "./setDetails.vue?vue&type=style&index=0&id=0dbec40b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbec40b",
  null
  
)

component.options.__file = "setDetails.vue"
export default component.exports